import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
} from "@mui/material";
import React from "react";

export interface LeaveSiteModalProps {
  open: boolean;
  onClose: () => void;
  onLeave: () => void;
}

export const LeaveSiteModal: React.FC<LeaveSiteModalProps> = ({
  open,
  onClose,
  onLeave,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="leave-site-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="leave-site-title">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" component="span">
            Leave Site?
          </Typography>
          <IconButton aria-label="close" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" sx={{ mb: 2 }}>
          The protocol hasn&apos;t been finalized yet. Are you sure you want to
          leave this page?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={onLeave} variant="contained" color="error">
          Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveSiteModal;
